import { useQuery } from "@tanstack/react-query";
import type { Environment } from "../../../types";
import type { GameSwapPool, GameSwapPortfolioResponse } from "../types";
import { getApiBase } from "../../../lib/remote-config";

export const GAME_SWAP_POOLS_QUERY_KEY = "wp:game-swap-pools";

/**
 * game-swap `GET /addresses/:address/portfolio` — 사용자가 참여한 LP 풀 목록.
 * 응답 body는 envelope 없이 `{ holdings, pools }`가 최상위로 내려온다.
 */
export function useGameSwapPools(
  env: Environment,
  walletAddress: string,
  enabled = true,
) {
  const isEnabled = enabled && !!walletAddress;

  const { data, ...rest } = useQuery<GameSwapPool[]>({
    queryKey: [GAME_SWAP_POOLS_QUERY_KEY, env, walletAddress],
    queryFn: async ({ signal }) => {
      const baseUrl = await getApiBase("gameSwap", env);
      const res = await fetch(
        `${baseUrl}/addresses/${walletAddress}/portfolio`,
        { cache: "no-store", signal },
      );
      if (!res.ok) throw new Error(`Game-swap portfolio fetch failed: ${res.status}`);
      const json: GameSwapPortfolioResponse = await res.json();
      return json.pools ?? [];
    },
    enabled: isEnabled,
    staleTime: 0,
  });

  return { pools: data ?? [], ...rest };
}
